import React from 'react';
import { SvgIcon } from '@mui/material';

export function TickSuccessIcon(props) {
  return (
    <SvgIcon viewBox="0 0 11 9" {...props}>
      <svg
        width="11"
        height="9"
        viewBox="0 0 11 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 4.93972L3.70833 7.66699L9.66667 1.66699"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </SvgIcon>
  );
}
